import React, { Suspense } from "react";
import { configureAmplifyCore } from "./config/configureAmplify";
import 'normalize.css';
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { getOptions } from "./util/functions";
import { createRoot } from "react-dom/client";
import App from "./App";
import Chatbot from "./Chatbot";

let { fullView, darkMode } = getOptions()

configureAmplifyCore();

const root = createRoot(document.getElementById("root"));

root.render(
    <Suspense fallback={
        <div style={{ padding: '1rem', color: 'white' }}>
            Loading...
        </div>}
    >
        {fullView ?
            <Chatbot fullView={fullView} darkMode={darkMode} />
            : <App darkMode={darkMode} />}
    </Suspense>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
